import { Theme, makeStyles } from "@material-ui/core"
import styled from "styled-components"

const useStyles = makeStyles((theme: Theme) => ({
    svgChecked: {
        height: "24px",
        width: "24px",
        "& path": {
            strokeWidth: "1px",
        },
    },
}))

interface StepNumberProps {
    background?: string
}

interface BodyContainerProps {
    paddingLeft?: string
}

export const StepNumber = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: ${({ background }: StepNumberProps) => background};
  border-radius: 50%;
  width: 24px;
  height: 24px;
`

export const BodyContainer = styled.div<BodyContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: ${({ paddingLeft }) => paddingLeft};
  gap: 16px;
  width: 100%;
`

export default useStyles
